import React, { Component } from 'react';
import Autocomplete from 'react-autocomplete';
import unorm from 'unorm';
import _ from 'lodash';

const menuStyle = {
  boxShadow: '0 2px 12px rgba(0, 0, 0, 0.1)',
  background: 'rgba(255, 255, 255, 0.9)',
  fontSize: '90%',
  position: 'fixed',
  zIndex: 2,
  overflow: 'auto',
  maxHeight: '300px',
  width: 'auto'
};

const wrapperStyle = {
  width: '100%'
};

const style = {
  background: '#fff',
  outline: 'none',
  color: 'rgb(185, 183, 183)',
  border: 'solid 1px #ccc',
  borderRadius: '4px',
  fontSize: '12px',
  padding: '6px 8px',
  width: '100%',
  fontFamily: 'latoregular'
};

const styleMenu = isHighlighted => {
  return {
    color: isHighlighted ? 'white' : '#687676',
    background: isHighlighted ? '#f99e60' : 'white',
    padding: '8px 5px',
    textAlign: 'left'
  };
};

class AutocompleteComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: props.value,
      memory: props.memory,
      filter: props.filter
    };
  }

  componentDidMount() {}

  componentWillReceiveProps(prevProps) {
    if (prevProps.clearRow == true) {
      this.setState({ value: '', memory: '' });
    }
  }

  handleChange = (e, value, arr) => {
    const alias = this.props.alias;
    const aliasTwo = this.props.aliasTwo;
    let a = _.filter(this.props.filter, function(item) {
      const a = unorm
        .nfd(item[alias])
        .toUpperCase()
        .replace(/[\u0300-\u036f]/g, '');
      const b = unorm
        .nfd(value)
        .toUpperCase()
        .replace(/[\u0300-\u036f]/g, '');

      const c = unorm
        .nfd(item[aliasTwo])
        .toUpperCase()
        .replace(/[\u0300-\u036f]/g, '');
      const d = unorm
        .nfd(value)
        .toUpperCase()
        .replace(/[\u0300-\u036f]/g, '');
      return a.includes(b) || c.includes(d);
    });
    this.setState({
      value: value,
      filter: a
    });
  };

  handleClick = event => {
    this.setState({
      value: '',
      filter: this.props.filter
    });
  };
  handleBlur = event => {
    this.setState({
      value: this.state.memory,
      filter: this.props.filter
    });
  };

  handleSelect = async (value, arr) => {
    this.props.handleSubmitAutoComplete({ value, id: this.props.id });
    this.setState({
      value: value,
      memory: value
    });

    if (this.props.allocatorActions) {
      this.props.allocatorActions.isDuplicate(value);
    }
    //this.props.handleSelect(value, value);
    const obj = {
      id: this.props.id,
      num: this.props.correlativo,
      value: arr,
      alias: this.props.alias
    };
    //  this.props.handleSubmit(obj);
    if (this.props.checkIfExist) {
      this.props.checkIfExist.checkIfExist();
      //document.getElementById('au-2').focus();
      // this.setState({
      //   value: value,
      //   memory: value
      // });
    }
    //  const autoComplete = document.getElementById('au-2').focus();

    if (this.props.handleDriverName) {
      this.props.handleDriverName(value, this.props.i);
      if (this.props.handleChangeSelectedName) {
        if ((this.props.i == 0) | (this.props.i > 0)) {
          this.props.handleChangeSelectedName(this.props.i, value);
        }
      }
    }
  };

  handleClear = value => {
    this.setState({
      value: this.props.value,
      memory: this.props.value
    });
    const obj = {
      id: this.props.id,
      num: this.props.correlativo,
      value: null,
      alias: this.props.alias
    };
    this.props.handleSubmit(obj);
  };

  handleClearInput = () => {
    this.setState({
      value: this.props.value,
      memory: this.props.value
    });
    //  this.props.unClear();
    //  this.props.handleFocus();
  };

  handleCLose = e => {
    console.log(e);
  };

  render() {
    return (
      <div className="box-clear">
        <Autocomplete
          inputProps={{
            'data-autocomplete': 'complete',
            'data-num': this.props.correlativo,
            id: this.props.id,
            style: style,
            onClick: this.handleClick,
            onBlur: this.handleBlur
          }}
          menuStyle={menuStyle}
          wrapperStyle={wrapperStyle}
          getItemValue={item => item[this.props.alias]}
          items={this.state.filter}
          renderItem={(item, isHighlighted) => (
            <div key={item[this.props.idItem]} style={styleMenu(isHighlighted)}>
              {`${item[this.props.alias]} - ${item[this.props.aliasTwo]}`}
            </div>
          )}
          value={this.state.value}
          onChange={this.handleChange}
          onSelect={this.handleSelect}
          onClose={this.handleCLose}
          openOnFocus={true}
        />
        {this.state.memory != this.props.value && (
          <div className="box-clear-button">
            <button onClick={this.handleClear}>
              <i className="fas fa-times-circle" />
            </button>
          </div>
        )}
      </div>
    );
  }
}

export default AutocompleteComponent;



// WEBPACK FOOTER //
// ./source/client/components/allocator/autocomplete.jsx